import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import PointsOfInterestEditForm from './PointsOfInterestEditForm';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceAndLocalisationById from 'components/hoc/fetchResourceAndLocalisationById';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { fetchPointOfInterest } from 'store/actions/pointsofinterest/fetchPointsOfInterest';
import { updatePointOfInterest } from 'store/actions/pointsofinterest/updatePointsOfInterest';
import { omit } from 'lodash';

class PointsOfInterestEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            system,
        } = this.context.config.language;

        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        const { localisation, ...pointOfInterest } = values;

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: (error) => {
                    let formErrors = {
                        _error: false,
                    };

                    if (error.response.message === 'location-could-not-be-resolved') {
                        formErrors.address = translate('forms.error.location-could-not-be-resolved');
                        formErrors._error = true;
                    }

                    if (formErrors._error) {
                        reject(new SubmissionError(formErrors));
                    }
                },
                onSuccess: () => {
                    resolve(history.push(`/pointsofinterest/${ id }/show`));
                },
                formValues: {
                    base: {
                        ...pointOfInterest,
                        ...localisation[system],
                    },
                    localisation: utils.filterEmptyValues(omit(localisation, [
                        'es',
                        'it',
                    ])),
                },
                id,
            });
        });
    }

    render() {
        const {
            data,
            localisation,
            resourceFetchLoading,
            resourceFetchFailed,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.points_of_interest.title'),
                link: '/pointsofinterest',
            },
            {
                label: data.name,
                link: `/pointsofinterest/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.points_of_interest.actions.edit', { title: data.name }) } />

                    <Actions>
                        <ListButton url='/pointsofinterest' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <PointsOfInterestEditForm
                            data={ data }
                            localisation={ localisation }
                            form='points_of_interest_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

PointsOfInterestEditContainer.contextTypes = {
    config: PropTypes.object,
};

PointsOfInterestEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object,
    id: PropTypes.number,
    localisation: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updatePointOfInterest(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceAndLocalisationById({
        action: fetchPointOfInterest,
        resource: 'pointsofinterest',
    })
);

export default enhance(PointsOfInterestEditContainer);



// WEBPACK FOOTER //
// ./src/pages/pointsofinterest/edit/PointsOfInterestEditContainer.js